const state = {
  address: '',
  unit: ''
};

const getters = {
  ownership: state => state
};

const actions = {
  setOwnership({commit}, ownership) {
    return commit('SET_OWNERSHIP', ownership);
  },
  setOwnershipAddress({commit}, address) {
    return commit('SET_OWNERSHIP_ADDRESS', address);
  },
  setOwnershipUnit({commit}, unit) {
    return commit('SET_OWNERSHIP_UNIT', unit);
  },
  clearOwnership({commit}) {
    return commit('SET_OWNERSHIP', {unit: '', address: ''});
  }
};

const mutations = {
  SET_OWNERSHIP(state, ownership) {
    state.unit = ownership.unit;
    state.address = ownership.address;
  },
  SET_OWNERSHIP_UNIT(state, unit) {
    state.unit = unit;
  },
  // Set the Address if there's only a single one
  SET_OWNERSHIP_ADDRESS(state, address) {
    state.address = address;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
